import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a0be2952&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports